import React from 'react';
import { FaPhoneAlt, FaCarSide, FaSmile } from 'react-icons/fa'; // Import icons
import './HowItWorksSection.css';

const HowItWorksSection: React.FC = () => (
  <div className="how-it-works-section">
    <h2>How Yenro Auto Mobile Car Detailing Works</h2>
    <div className="steps-container">
      <div className="step">
        <FaPhoneAlt className="step-icon" />
        <h3>Dial-In or Book Online</h3>
        <p>Schedule your appointment conveniently over the phone or via our online booking platform.</p>
      </div>
      <div className="step">
        <FaCarSide className="step-icon" />
        <h3>Let Us Come to You</h3>
        <p>We’ll come to your location, whether it’s your home or office, to service your vehicle.</p>
      </div>
      <div className="step">
        <FaSmile className="step-icon" />
        <h3>Enjoy Our Service</h3>
        <p>Relax and enjoy our premium service with a 100% satisfaction.</p>
      </div>
    </div>
  </div>
);

export default HowItWorksSection;
